import React from "react";
import PublicPage from "../../../containers/PublicPage/index";
import { Consumer } from "../../../containers/Context";
import { getMessage } from "../../../lib/translator";
import LoginForm from "../Login/form";
import { ZOPPING_URL } from "../../../config/app";
import "../Verify/verify.css";

export default function AccountCreated() {
  const handleSignUpRedirection = () => {
    window.location.href = `${ZOPPING_URL}?sign-up=true`;
  };

  return (
    <PublicPage className="eazy-page">
      <div className="verify">
        <header className="header">
          <h1 className="heading">{getMessage("account.created")}</h1>
          <h2 className="span subheading">
            {getMessage("verification.email.sent")}
          </h2>
        </header>
      </div>
      <Consumer>
        {(isEnterprise) => (
          <div className="account-created-wrp">
            <div className="password-sent-mobile">
              {getMessage("use.password.sent.to.registered.mobile")}
            </div>
            <LoginForm enterprise={isEnterprise} />
            {!isEnterprise && (
              <p className="alt-action">
                {getMessage("login.newUser.message")}{" "}
                <span
                  onClick={handleSignUpRedirection}
                  className="sign-up-redirection"
                >
                  {getMessage("login.newUser.signupText")}
                </span>
                <br />
                <br />
                <div>{getMessage("account.creation.happens.on.zopping")}</div>
              </p>
            )}
          </div>
        )}
      </Consumer>
    </PublicPage>
  );
}
